import { Text } from '@myinterview/component-library';
import React from 'react';

interface IProps {
  currentLength: number;
  maxLength: number;
}

export const CharactersLimit:React.FC<IProps> = ({ currentLength, maxLength }) => (
  <Text className="myinterview-widget__characters-limit" size="S-Regular">
    {currentLength}
    {' '}
    /
    {' '}
    {maxLength}
  </Text>
);
